const dataJson = {
    lines: [
        {start:[121.6106, 38.9137],end:[102.8468, 24.87951]},
        {start:[121.6106, 38.9137],end:[87.6033, 43.82109]},
        {start:[121.6106, 38.9137],end:[104.10205, 30.6620]},
        {start:[121.6106, 38.9137],end:[114.3385,30.6251]},
        {start:[121.6106, 38.9137],end:[111.6893,28.9886]},
        {start:[121.6106, 38.9137],end:[101.2029,37.4193]},
        {start:[121.6106, 38.9137],end:[91.0108,29.7621]},
        {start:[121.6106, 38.9137],end:[119.2690,26.1693]},
        {start:[121.6106, 38.9137],end:[114.3385,22.7684]},
        {start:[121.6106, 38.9137],end:[124.7480,42.5414]},
        {start:[121.6106, 38.9137],end:[126.6613,45.9006]},
        {start:[113.3261,23.1842],end:[93.751447,35.883713]},
        {start:[113.3261,23.1842],end:[100.632036,30.758856]},
        {start:[113.3261,23.1842],end:[111.560031,40.946273]},
        {start:[113.3261,23.1842],end:[108.874025,34.433284]},
        {start:[113.3261,23.1842],end:[117.116014,36.717672]},
        {start:[113.3261,23.1842],end:[110.67696,29.414927]},
    ],
    bars: [{name:'大连',lct:[121.6106, 38.9137],value:666},{name:'上海',lct:[121.4721,31.2417],value:888}],//没有则不显示柱子
    mapData:[
        {name:'云南',value:2},
        {name:'新疆',value:2},
        {name:'四川',value:60},
        {name:'湖北',value:80},
        {name:'湖南',value:40},
        {name:'青海',value:20},
        {name:'西藏',value:10},
        {name:'福建',value:60},
        {name:'广东',value:120},
        {name:'辽宁',value:6},
        {name:'黑龙江',value:116},
    ]
}

export default {
    cptDataForm: {
        dataSource: 1, pollTime: 0,
        dataText: JSON.stringify(dataJson),
    },
    attribute: {
        color: ['#0a2a63','#2a53b9','#0ca5eb','#14dfe6'],
        provinceCode:'china',cityCode:'',
        title: {
            text: '',
            left: 'center',
            top: 'top',
            textStyle: {
                fontSize: 18,
                color: '#ccc'
            }
        },
        itemStyle:{
            borderColor: '#2e7fc0',
            color: '#083785',
            borderWidth: 1,
        },
        label: {
            show: true,
            fontSize: 10,
            color: '#fff'
        },
        visualMap: {
            show: true,
            min: 0,
            max: 200,
            left: '20',
            top: 'bottom',
            seriesIndex:0,
            textStyle: {
                color: '#ddd'
            },
            pieces: [{
                gte: 100,
                label: '> 100'
            }, {
                gte: 50,
                lt: 100,
                label: '50 - 100'
            }, {
                gte: 10,
                lt: 50,
                label: '10 - 50'
            }, {
                gte: 0,
                lt: 10,
                label: '1-10'
            }],
        },
        bar:{
            color:'#1ca2f9',
            barSize:1.6,
        },
        line:{
            lineStyle: {
                width: 1,
                color: '#8bc1ec',
                opacity: 0.4
            },
            endPoint:{
                symbolSize: 8,
                itemStyle: {
                    color: '#0470fe'
                }
            }
        },
        cptTableData: [{ "name": "类型", "value": "", "namekey": "type" },
        { "name": "维度", "value": "", "namekey": "name" },
        { "name": "指标", "value": "", "namekey": "value" },
        { "name": "开始坐标", "value": "", "namekey": "start" },
        { "name": "结束坐标", "value": "", "namekey": "end" }] 
    },
}
